export { default } from './ChipTag'
export type { ChipTagData, ChipTagProps } from './ChipTag'
